const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VARIANTS = ["A", "B", "C"];
const VARIANT_KEY = "rla1_hero_variant";

export const getHeroVariant = () => {
  // A/B-randomisatie gepauzeerd: hero toont vast de hoofdboodschap (variant A).
  // Zet hieronder weer randomisatie aan zodra nieuwe varianten getest moeten worden.
  return "A";
};

const getUtm = () => {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  return utm;
};

export const track = (event, props = {}) => {
  try {
    const payload = {
      event,
      device: window.innerWidth < 768 ? "mobile" : "desktop",
      referrer: document.referrer || undefined,
      hero_variant: getHeroVariant(),
      ...getUtm(),
      ...props,
    };
    fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* analytics mag nooit de site breken */
  }
};
